module.exports = __webpack_public_path__ + "img/vignette2.70bb8df1.jpg";